import { CompetitionDetailsGameplay } from 'components/competitionDetails/Gameplay';

import { useLayoutData } from '../layoutData';

const Gameplay = () => {
  const { data } = useLayoutData();
  const { nbaLeaderboard } = data ?? {};
  const { league: leagueLeaderboard } = nbaLeaderboard ?? {};

  let leaderboard = nbaLeaderboard;
  if (leagueLeaderboard) {
    if (nbaLeaderboard) {
      const lineupsCount = leagueLeaderboard.lineupCount;
      leaderboard = { ...nbaLeaderboard, lineupsCount };
    }
  }

  return <CompetitionDetailsGameplay leaderboard={leaderboard} fullPage />;
};
export default Gameplay;
